





































































































































































































































































































import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import storeBilling from "@/store/modules/Billing";
import RegisterKunjunganSvc from "@/services/RegisterKunjungan";
import Billing from "@/services/Billing";
import DataPasien from "@/services/DataPasien";
import LockingRegister from "@/utility/LockingRegister";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import CardModalBatalAskepRanap from "@/components/modal/CardModalBatalAskepRanap.vue";

@Component({
  components: { CardModalBatalAskepRanap },
  inject: {
    isReadOnly: { default: () => () => false }
  },
  beforeRouteLeave(to, from, next) {
    LockingRegister.unlockRegister("bangsal");
    next();
  }
})
export default class AskepRanap extends Vue {
  @Prop() pasien: any;
  @Prop() status = "1";
  @Prop() disSimpan = true;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }
  maxDate = moment().format("YYYY-MM-DD");
  tglIsi = moment().format("YYYY-MM-DD");
  today = moment().format("YYYY-MM-DD");
  jam = moment().format("HH");
  // pasien = null;
  catatan = null;
  rm = null;
  shift = null;
  register = null;
  tglShow = false;
  saving = false;
  modalBatal = false;
  disBatal = true;
  // disSimpan = true;
  ruang_rawat = "";
  aktivitas_dasar = "";
  alat_medis = "";
  observasi = "";
  ekg = "";
  perawatan = "";
  infus = "";
  intake_output = "";
  operasi = "";
  suction = "";
  bronchial = "";
  itemShift = [
    { id: "1", nama: "Pagi" },
    { id: "2", nama: "Siang" },
    { id: "3", nama: "Malam" }
  ];

  get tglIsiFormattedMomentjs() {
    return this.tglIsi ? moment(this.tglIsi).format("DD-MM-YYYY") : "";
  }
  get kondisi() {
    return storeBilling.kondisiDasar;
  }
  get stateuser() {
    return userModule.user;
  }
  get askep() {
    return storeBilling.askep;
  }
  get showLoading() {
    return storeBilling.loading;
  }
  get inputAskep() {
    let inp: any;
    if (this.pasien) {
      inp = {
        tanggal: this.tglIsi,
        unit_id: this.stateuser.unit_id,
        rm: this.pasien.rm,
        kelas: this.pasien.kelas,
        register_id: this.pasien.register.no,
        register_tgl: this.formatTgl(this.pasien.register.tgl),
        shift: this.shift.id,
        catatan: this.catatan,
        kondisi_dasar: {
          ruang_rawat: this.ruang_rawat,
          aktivitas_dasar: this.aktivitas_dasar,
          alat_medis: this.alat_medis,
          observasi: this.observasi,
          ekg: this.ekg,
          perawatan: this.perawatan,
          infus: this.infus,
          intake_output: this.intake_output,
          operasi: this.operasi,
          suction: this.suction,
          bronchial: this.bronchial
        }
      };
    }
    return inp;
  }

  mounted() {
    window.onbeforeunload = function() {
      LockingRegister.unlockRegister("bangsal");
      return "";
    };
    storeBilling.getKondisiDasar(this.stateuser.unit_id);
    this.getShift();
  }
  batal() {
    this.modalBatal = true;
  }
  batalAkses() {
    this.rm = null;
    this.register = null;
    this.pasien = null;
    this.disSimpan = true;
  }
  getAskep() {
    const param = {
      tanggal: this.tglIsi,
      unit_id: this.stateuser.unit_id,
      rm: this.pasien.rm,
      register_id: this.pasien.register.no,
      shift: this.shift.id
    };
    storeBilling.getAskep(param);
  }
  lockRegister() {
    const dt = Billing.lockRegister(
      this.register.no,
      this.stateuser.id,
      this.stateuser.unit_id,
      "bangsal"
    );
    dt.then(dt => {
      if (dt.status != 1) {
        appModule.sendErrorAlert(dt.message);
        this.batalAkses();
        // this.modalAksesTindakan = false;
      }
    });
  }
  unlockRegister() {
    if (this.register) {
      const dt = Billing.unlockRegister(
        this.register.no,
        this.stateuser.id,
        "bangsal"
      );
      dt.then(dt => {
        if (dt.status != 1) {
          // appModule.sendErrorAlert(dt.message);
        }
      });
    }
  }
  formatTgl(date) {
    const [day, month, year] = date.split("-");
    return year + "-" + month + "-" + day;
  }
  changeDate() {
    if (this.rm) {
      this.clearAskep();
      this.getAskep();
      this.changeShift();
    } else {
      this.changeShift();
    }
  }
  suksesBatal() {
    this.clearAskep();
    this.getAskep();
  }
  clearAskep() {
    this.disBatal = true;
    this.ruang_rawat = "";
    this.aktivitas_dasar = "";
    this.alat_medis = "";
    this.observasi = "";
    this.ekg = "";
    this.perawatan = "";
    this.infus = "";
    this.intake_output = "";
    this.operasi = "";
    this.suction = "";
    this.bronchial = "";
    this.catatan = null;
  }
  getShift() {
    if (Number(this.jam) >= 20) this.shift = { id: "3", nama: "Malam" };
    else if (Number(this.jam) >= 14) this.shift = { id: "2", nama: "Siang" };
    else this.shift = { id: "1", nama: "Pagi" };
  }
  changeShift() {
    if (this.today == this.tglIsi) {
      if (!this.rm) {
        if (Number(this.jam) >= 20) {
          // this.shift = { id: "3", nama: "Malam" };
        } else if (Number(this.jam) >= 14) {
          if (this.shift.id == "3") {
            this.shift = { id: "2", nama: "Siang" };
          }
        } else {
          if (this.shift.id == "2") {
            this.shift = { id: "1", nama: "Pagi" };
          } else if (this.shift.id == "3") {
            this.shift = { id: "1", nama: "Pagi" };
          }
        }
      } else {
        if (Number(this.jam) >= 20) {
          // this.shift = { id: "3", nama: "Malam" };
        } else if (Number(this.jam) >= 14) {
          if (this.shift.id == "3") {
            appModule.sendErrorAlert("Belum dapat mengakses shift 3");
            this.shift = { id: "2", nama: "Siang" };
          }
        } else {
          if (this.shift.id == "2") {
            appModule.sendErrorAlert("Belum dapat mengakses shift 2");
            this.shift = { id: "1", nama: "Pagi" };
          } else if (this.shift.id == "3") {
            appModule.sendErrorAlert("Belum dapat mengakses shift 3");
            this.shift = { id: "1", nama: "Pagi" };
          }
        }
        this.clearAskep();
        this.getAskep();
      }
    } else {
      this.clearAskep();
      this.getAskep();
    }
  }
  cariReg(rm) {
    this.clearAskep();
    this.register = null;
    this.pasien = null;
    const dt = DataPasien.getDataPasienLastReg(rm);
    dt.then(dt => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        if (dt.data[0].register) {
          this.pasien = dt.data[0];
          const reg = dt.data[0].register.no;
          const dataReg = RegisterKunjunganSvc.get(reg);
          dataReg.then(dataReg => {
            this.register = dataReg.data;
            RegisterKunjungan.getRegister(reg);
            if (this.register.dout != null) {
              appModule.sendErrorAlert(
                "RM " +
                  this.pasien.rm_dash +
                  " " +
                  this.pasien.nama +
                  ", sudah pulang tanggal " +
                  this.register.dout
              );
              this.batalAkses();
            } else {
              if (this.register.unit == this.stateuser.unit_id) {
                if (dt["status"] != 1) {
                  // appModule.sendErrorAlert(dt["message"]);
                } else {
                  this.lockRegister();
                  this.disSimpan = false;
                  this.getAskep();
                }
              } else {
                appModule.sendErrorAlert(
                  "RM " +
                    this.pasien.rm_dash +
                    " masih berada di " +
                    this.pasien.register.unit.nama
                );
                this.batalAkses();
              }
            }
          });
        } else {
          appModule.sendErrorAlert("Tidak ditemukan nomor register terakhir");
          this.batalAkses();
        }
      }
    });
  }
  simpan() {
    if (this.pasien) {
      if (this.validasiKondisiDasar() == true) {
        if (!this.saving) {
          this.saving = true;
          const dt = Billing.postAskep(this.inputAskep);
          dt.then(dt => {
            this.saving = false;
            if (dt["status"] != 1) {
              appModule.sendErrorAlert(dt["message"]);
            } else {
              appModule.NoticeDelay("Berhasil Simpan Asuhan Keperawatan");
              this.getAskep();
            }
          });
        }
      } else {
        appModule.sendErrorAlert("Silahkan Lengkapi Isian Kondisi Dasar");
      }
    } else {
      appModule.sendErrorAlert("Silahkan input No RM dahulu");
    }
    console.log("data=", this.inputAskep);
    // console.log("status=", this.validasiKondisiDasar());
  }
  validasiKondisiDasar() {
    if (this.kondisi) {
      if (this.kondisi.ruang_rawat == "1") {
        if (!this.ruang_rawat) {
          return false;
        }
      }
      if (this.kondisi.aktivitas_dasar == "1") {
        if (!this.aktivitas_dasar) {
          return false;
        }
      }
      if (this.kondisi.alat_medis == "1") {
        if (!this.alat_medis) {
          return false;
        }
      }
      if (this.kondisi.observasi == "1") {
        if (!this.observasi) {
          return false;
        }
      }
      if (this.kondisi.ekg == "1") {
        if (!this.ekg) {
          return false;
        }
      }
      if (this.kondisi.perawatan == "1") {
        if (!this.perawatan) {
          return false;
        }
      }
      if (this.kondisi.infus == "1") {
        if (!this.infus) {
          return false;
        }
      }
      if (this.kondisi.intake_output == "1") {
        if (!this.intake_output) {
          return false;
        }
      }
      if (this.kondisi.operasi == "1") {
        if (!this.operasi) {
          return false;
        }
      }
      if (this.kondisi.suction == "1") {
        if (!this.suction) {
          return false;
        }
      }
      if (this.kondisi.bronchial == "1") {
        if (!this.bronchial) {
          return false;
        }
      }
    }
    return true;
  }

  @Watch("rm")
  changeRm() {
    if (this.rm) {
      if (this.rm.length == 6) {
        this.cariReg(this.rm);
      } else {
        this.unlockRegister();
        this.clearAskep();
        this.register = null;
        this.pasien = null;
        this.disSimpan = true;
      }
    }
  }
  @Watch("askep")
  changeAskep(val) {
    if (val) {
      this.catatan = val.catatan;
      if (val.kondisi_dasar) {
        this.disBatal = false;
        this.ruang_rawat = val.kondisi_dasar.ruang_rawat;
        this.aktivitas_dasar = val.kondisi_dasar.aktivitas_dasar;
        this.alat_medis = val.kondisi_dasar.alat_medis;
        this.observasi = val.kondisi_dasar.observasi;
        this.ekg = val.kondisi_dasar.ekg;
        this.perawatan = val.kondisi_dasar.perawatan;
        this.infus = val.kondisi_dasar.infus;
        this.intake_output = val.kondisi_dasar.intake_output;
        this.operasi = val.kondisi_dasar.operasi;
        this.suction = val.kondisi_dasar.suction;
        this.bronchial = val.kondisi_dasar.bronchial;
      } else {
        this.disBatal = true;
        this.ruang_rawat = "";
        this.aktivitas_dasar = "";
        this.alat_medis = "";
        this.observasi = "";
        this.ekg = "";
        this.perawatan = "";
        this.infus = "";
        this.intake_output = "";
        this.operasi = "";
        this.suction = "";
        this.bronchial = "";
      }
    }
  }

  @Watch("status")
  changeStatus(val) {
    this.getAskep();
  }
}
